export const formatBoolean = (value: boolean | undefined): string => {
  if (value === undefined) return "-";
  return value ? "Yes" : "No";
};

export const formatCurrency = (value: number | undefined): string => {
  if (value === undefined) return "-";
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
};